function initHeader() {
  const headerGroup = document.querySelector('.header-group');
  if(!headerGroup) return;

  window.addEventListener('scroll', () => {
    handleHeaderScroll(headerGroup);
  });

  const header = document.querySelector('.section-header');
  if(!header) return;

  handleMenuTriggers(header);
}

function handleMenuTriggers(header) {
  const triggers = header.querySelectorAll('[data-trigger-menu]');
  const navigation = header.querySelector('[data-navigation]');
  if(!triggers || !navigation) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      navigation.classList.toggle('open');
      if(navigation.classList.contains('open')) {
        document.querySelector('html').style.overflow = "hidden";
      } else {
        document.querySelector('html').removeAttribute('style');
      }
    });
  });
}

function handleHeaderScroll(headerGroup) {
  if(window.scrollY > 10 && !headerGroup.classList.contains('scrolled')) {
    headerGroup.classList.add('scrolled');
  }

  if(window.scrollY < 10 && headerGroup.classList.contains('scrolled')) {
    headerGroup.classList.remove('scrolled');
  }
}

window.addEventListener('load', () => {
  initHeader();
});